export default __webpack_public_path__ + "assets/cash-machine-f1a559d3b864ba9e2e730cc02f283422.mp3";